import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const STATUS_LABELS = {
  quote_accepted: "Quote accepted",
  received: "Device received",
  parts_arrived: "Parts arrived",
  in_repair: "In repair",
  ready_for_pickup: "Ready for pickup",
  completed: "Completed",
  cancelled: "Cancelled",
};
